var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1280"
    }
  }, [_c('console-title', [_c('span', [_vm._v("팝업 목록")])]), _c('console-body', [_c('v-layout', {
    staticClass: "mt-2 px-1",
    attrs: {
      "align": "end"
    }
  }, [_c('span', {
    staticClass: "subtitle-2"
  }, [_vm._v("검색수 : " + _vm._s(_vm.summary.totalCount.format()))]), _c('v-spacer'), _c('span')], 1), _c('v-data-table', {
    staticClass: "mt-3 mx-1 elevation-1",
    attrs: {
      "items": _vm.popups,
      "headers": _vm.popupsHeaders,
      "hide-default-footer": "",
      "disable-sort": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          staticClass: "mx-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v("mdi-pencil")]), _vm.$hasScope(['root', 'admin']) ? _c('v-icon', {
          staticClass: "mx-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v("mdi-delete")]) : _vm._e()];
      }
    }, {
      key: "item.url",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [item.url ? _c('v-icon', {
          on: {
            "click": function click($event) {
              return _vm.move(item.url);
            }
          }
        }, [_vm._v("mdi-link")]) : _c('div', [_vm._v("-")])];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('div', [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YY-MM-DD HH:mm:ss")))])];
      }
    }], null, true)
  }), _c('v-pagination', {
    staticClass: "my-4",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _vm.$hasScope(['root', 'admin']) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "accent"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.popupDialog.open();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1) : _vm._e(), _c('popup-dialog', {
    ref: "popupDialog",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    },
    on: {
      "close": function close($event) {
        return _vm.search(false);
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }